import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { authService } from '../Services/auth.service';
import GetToken from '../Screens/authenticatie/GetToken';

let isRefreshing = false;
let refreshSubscribers = [];

const useAxiosCaller = () => {
  const navigate = useNavigate();

  const get = async (url) => requestHandler('get', url);
  const post = async (url, data) => requestHandler('post', url, data);
  const put = async (url, data) => requestHandler('put', url, data);
  const del = async (url) => requestHandler('delete', url);

  async function requestHandler(method, url, data = null) {

    try {
     
      const token = await validateToken();
     
      return await axios({
        method,
        url: `${process.env.REACT_APP_API_URL}${url}`,
        headers: { 'x-auth-token': token },
        data,
      });
    } catch (error) {
      handleError(error);
    }
  }

  const validateToken = async () => {
    
    const { JWT, Refresh } = GetToken();
    let token = JWT();

    if (!token) {
    
      await authService.logout();
      navigate('/login');
      return;
    }

    try {
   
     return handleTokenRefresh();
    } catch (error) {
      console.error("Token validation failed", error);
      if (error.response?.status === 403) {
        return await handleTokenRefresh();
      }

      if (error.response?.status === 401) {
        await authService.logout(); 
        navigate('/login');
      }

      throw error;
    }
  };

  const handleTokenRefresh = async () => {
    if (isRefreshing) {
      return new Promise((resolve) => {
        refreshSubscribers.push(resolve);
      });
    }

    isRefreshing = true;
    const { Refresh } = GetToken();
    const refreshToken = Refresh();

    try {
      
      
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/refresh`, {
        refreshToken,
      });

      const newAccessToken = response.data.accessToken;
      sessionStorage.setItem('jwt', JSON.stringify(newAccessToken ));
      sessionStorage.setItem('refresh', JSON.stringify(response.data.refreshToken ));

      // Notify all waiting requests
      refreshSubscribers.forEach((callback) => callback(newAccessToken));
      refreshSubscribers = [];
      isRefreshing = false;

      return newAccessToken;
    } catch (error) {
      console.error("Token refresh failed", error);
      await authService.logout();
      navigate('/login');
      isRefreshing = false;
      throw error;
    }
  };

  const handleError = (error) => {
    if (error.response?.status === 403) {
      authService.logout();
      navigate('/login');

      
    }

    if (error.response?.status === 401) {
      authService.logout();
      navigate('/login');
    }

    if(error.response?.status === 409){
      throw error;
    }

    console.error('Error occurred:', error);
    throw error;
  };

  return { get, post, put, del };
};

export default useAxiosCaller;
